import React, { useEffect, useRef } from 'react';
import { MessageBubble } from './MessageBubble';
import { ThinkingIndicator } from './ThinkingIndicator';

export const MessageList = ({ messages, statusTool, busy, onSuggestedAction, agentName, convId }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [messages, busy, statusTool]);

  // Derive the latest user-typed message so the indicator can pick a
  // phrase track that matches what we're actually working on.
  const lastUserMessage = React.useMemo(() => {
    for (let i = messages.length - 1; i >= 0; i -= 1) {
      if (messages[i].role === 'user') return messages[i].content || '';
    }
    return '';
  }, [messages]);

  return (
    <div ref={ref} data-testid="ai-agent-message-list" className="flex-1 overflow-y-auto px-4 py-2">
      {messages.length === 0 && !busy && (
        <div className="text-center text-xs text-slate-400 mt-12">
          Ask me anything about your data, reports, or where to click.
        </div>
      )}
      {messages.map((m) => (
        <MessageBubble
          key={m.id || m.ts}
          message={m}
          onSuggestedAction={onSuggestedAction}
          suggestedDisabled={busy}
          agentName={agentName}
          convId={convId}
        />
      ))}
      {busy && (
        <div className="flex justify-start my-2">
          <ThinkingIndicator lastUserMessage={lastUserMessage} tool={statusTool} agentName={agentName} />
        </div>
      )}
    </div>
  );
};

export default MessageList;
